import { assets } from "@/config/site";
import { Section } from "./Section";
import { Reveal, ImageReveal, Parallax } from "./Reveal";

export const Studio = () => (
    <Section id="studio" index="13" label="The Studio" title="Where the work happens.">
        <div className="mt-14 grid gap-6 lg:grid-cols-12">
            <ImageReveal className="lg:col-span-7" delay={0.05}>
                <Parallax amount={30} className="h-full">
                    <img
                        src={assets.facility}
                        alt="Revautoz facility in Colvale, Mapusa — detailing bays and showroom under the Ride. Redefined. signboard"
                        loading="lazy"
                        decoding="async"
                        className="aspect-[4/3] w-full scale-[1.08] border border-rz-steel/60 object-cover lg:aspect-auto lg:h-full"
                    />
                </Parallax>
            </ImageReveal>
            <div className="grid gap-6 lg:col-span-5">
                <ImageReveal delay={0.12}>
                    <img
                        src={assets.banner}
                        alt="Revautoz signage — Ride. Redefined. Detailing, PPF, Ceramic, Restoration, Custom, Bodyshop"
                        loading="lazy"
                        decoding="async"
                        className="w-full border border-rz-steel/60 object-cover"
                    />
                </ImageReveal>
                <ImageReveal delay={0.18}>
                    <img
                        src="/assets/work/studio-floor.webp"
                        alt="Real Revautoz studio — technicians working across a BMW X7, BMW Z4 and Mercedes GLA on the detailing floor"
                        loading="lazy"
                        decoding="async"
                        className="aspect-[16/10] w-full border border-rz-steel/60 object-cover"
                    />
                </ImageReveal>
                <ImageReveal delay={0.24}>
                    <img
                        src="/assets/work/studio-floor-2.webp"
                        alt="Real Revautoz studio — a second view of the floor with multiple vehicles in progress"
                        loading="lazy"
                        decoding="async"
                        className="aspect-[16/10] w-full border border-rz-steel/60 object-cover"
                    />
                </ImageReveal>
            </div>
        </div>
        <Reveal className="mt-10" delay={0.1}>
            <p className="max-w-[60ch] text-base leading-relaxed text-rz-smoke">
                Our Goa facility — detailing bays, protection and coating areas, and a full bodyshop
                under one roof. Easy to reach from Mapusa, Colvale and across Bardez and North Goa.
            </p>
        </Reveal>
    </Section>
);
